// Check if there is a browser window open.
// If there is a window defined, it will check the userAgent for what type of browser, if it is Safari it will return true.
let isSafari = false;
if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// If the user uses safari, it will display a message on the sign in page.
export function BrowserAgent() {
  if (isSafari === true) {
    return (
      "Vi ser at du bruker Safari som nettleser," +
      "\n" +
      "det er anbefalt å bruke Chrome, Firefox eller en annen nettleser for alle funksjoner i web skal fungere."
    );
  } else {
    return "";
  }
}
